import { pathWithParams } from './herawApiPaths';
import { WorkspaceFeature } from '../types/workspace.types';
import { folderLink, projectsLink } from './herawFrontUris';
import { featureACL } from '../utils/acl';

//trailing slashs are important to preserve query params
export const SIGNUP = `/:lang/sign-up/:type/:plan`;
export const SIGNIN = `/:lang/sign-in/`;
export const RESET_PASSWORD = `/:lang/password-reset/`;

export const ADMITTANCE = `/:lang/admittance/`;

export const signUpLink = (lang: string, type: string, plan?: string) =>
    process.env.APP_URL + pathWithParams(SIGNUP, { lang, type, plan });
export const signInLink = (
    lang = 'fr',
    query?: {
        email?: string;
        redirect?: string;
        error?: string;
        token?: string;
        // This token will be associated to an API KEY server side for retrieval from Da Vinci resolve and Adobe integrations
        pluginAuthToken?: string | null;
    }
) => process.env.APP_URL + pathWithParams(SIGNIN, { lang }, query);

export const resetPasswordLink = (lang = 'fr', query?: { email?: string; token?: string }) =>
    process.env.APP_URL + pathWithParams(RESET_PASSWORD, { lang }, query);

export const admittanceLink = (lang = 'fr', clientName: string, folderUuid: string) =>
    process.env.APP_URL + pathWithParams(ADMITTANCE, { lang }, { clientName, folderUuid });

export function getLoginRoute(workspaceName: string, features: WorkspaceFeature[]) {
    if (featureACL.projects(features)) {
        return projectsLink(workspaceName);
    }
    return folderLink(workspaceName);
}
